import React, { ReactNode } from 'react';
import AppText, { Mode } from '../atomic/AppText';

export function Header2(props: { children: ReactNode }) {
  return <AppText mode={Mode.HEADER2}>{props.children}</AppText>;
}
